import { ContentBlock } from '@/components/ui/ContentBlock'

export const ProgrammePersonalisation = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <ContentBlock title="Personalised to You">
        <p>There is no single Instrumental Health protocol that every client follows.</p>
        <p>
          Two people may arrive with similar concerns but have very different health histories,
          nutritional needs, lifestyles, stressors and priorities. Your programme reflects those
          differences.
        </p>
        <p>
          Throughout the 12 weeks, your progress is monitored and your recommendations can be
          adapted as your needs change.
        </p>
        <p>
          The aim is not simply to tell you what to do, but to help you understand your body,
          recognise your own health patterns and develop practical tools that you can continue to
          use beyond the programme.
        </p>
      </ContentBlock>
    </div>
  </section>
)
